<a routerLink="../last-videos">
    <img src="../../../assets/images/new-logo.png" />
</a>
<search class="search" [showBlocked]="showBlocked" (makeSearch)="searchVideosAndTags($event)"></search>
<div>
    <div *ngIf="showCheckbox != false&&hasYoutubeNakiProfile" class="checkbox-container">
        <input type="checkbox" id="showBlockedCheckbox" name="showBlockedCheckbox" [disabled]="loadingVideos"
            class="checkbox" [(ngModel)]="showBlocked" (change)="showBlockesSave()" />
        <label for="showBlockedCheckbox">כלול סרטונים שאינם פתוחים בחשבונך</label>
    </div>
</div>